import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'summary-overview-label',
	templateUrl: './summary-overview-label.component.html',
	imports: [TranslatePipe],
})
export class SummaryOverviewLabelComponent {
	year = input<number>();
}
